import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { handleNavigate } from "../../../../hooks/handleNavigate";
import { resetSectionList, updateSection } from "../../assignmentSlice";

import TypeBox from "./TypeBox";

const TopBar = ({
  currentStep,
  setCurrentStep,
  isPreview = false,
  isReview = false,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { assignment, paragraph, section } = useSelector(
    (state) => state.assignment
  );
  const { mode } = useSelector((state) => state.ui);
  // [상단바 v7] redux mode가 PC로 남아 폰에서 70px 바가 뜨던 것 → 실측 판정 OR
  const isMobile = mode === "mobile" || Math.min(window.innerWidth, window.screen.width) <= 768;

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between", // 좌우로 정렬
        alignItems: "center", // 세로 방향 중앙 정렬
        height: isMobile ? "45px" : "70px",
      }}
    >
      {/* 좌측 콘텐츠 */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          fontSize: isMobile ? "12px" : "14px",
          gap: isMobile ? "6px" : "1.5vw",
          // [상단바 깨짐] 긴 제목이 저장 버튼을 밀어내던 것 → 남은 폭만 사용
          flex: 1,
          minWidth: 0,
          overflow: "hidden",
        }}
      >
        <TypeBox type={assignment?.type || "analysis"} isMobile={isMobile} />
        <div style={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          // [모바일 제목] 최대 폭 제한 — 복습 배지+저장 버튼 공간 확보
          maxWidth: isMobile ? "120px" : "none",
          flexShrink: 1,
        }}>{assignment?.title || ""}</div>
        <div
          style={{
            fontSize: "14px",
            color: "#737373",
          }}
        >
          {assignment?.is_retry && (
            <span style={{
              backgroundColor: "#E8F7EE",
              color: "#1DB05B",
              padding: "4px 10px",
              borderRadius: "999px",
              fontSize: "12px",
              fontWeight: 800,
              whiteSpace: "nowrap",
              flexShrink: 0,
              marginRight: "6px"
            }}>
              복습 {assignment.retry_info?.retry_count || ''}회차
            </span>
          )}
          {/* [중복 제목 수정] 어법테스트처럼 과제 제목과 지문 제목이 같으면
              ("0807 중등" × 2) 같은 글자가 두 번 떠 보임 → 다를 때만 표시.
              제목이 다른 과제(지문분석 등)는 기존처럼 둘 다 나온다. */}
          {!isMobile && paragraph?.title &&
          paragraph.title.trim() !== (assignment?.title || "").trim()
            ? paragraph.title
            : ""}
        </div>
      </div>

      {/* 우측 버튼 */}
      <button
        style={{
          backgroundColor: "#0E141B",
          borderRadius: "999px",
          border: "none",
          color: "#FFF",
          padding: isMobile ? "6px 14px" : "10px 22px",
          flexShrink: 0,
          whiteSpace: "nowrap",
          cursor: "pointer",
          fontSize: isMobile ? "12px" : "15px",
          fontWeight: 700,
          fontFamily: "inherit",
          transition: "background-color .12s",
        }}
        onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#00A396")}
        onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#0E141B")}
        onClick={() => {
          alert("학습 내역이 저장되었습니다.");
          if (currentStep > 1) {
            if (
              currentStep === 3 &&
              !isPreview &&
              !isReview &&
              section.type != "unknown"
            ) {
              const isFinished =
                !["study", "matching"].includes(section.type) &&
                section.answer.length != 0 &&
                !section.answer.some((page) => page.isSubmitted == false);
              dispatch(
                updateSection({
                  sectionId: section.id,
                  data: { answer: section.answer, is_finished: isFinished },
                })
              );
            }
            setCurrentStep(currentStep - 1);
          } else {
            if (isPreview || isReview) {
              window.close();
            } else {
              handleNavigate({ url: "/home", params: {}, navigate });
              dispatch(resetSectionList());
            }
          }
        }}
      >
        저장하고 나가기
      </button>
    </div>
  );
};

export default TopBar;
